import { render, staticRenderFns } from "./UserTrainning.vue?vue&type=template&id=f383fdcc&scoped=true&"
import script from "./UserTrainning.vue?vue&type=script&lang=js&"
export * from "./UserTrainning.vue?vue&type=script&lang=js&"
import style0 from "./UserTrainning.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserTrainning.vue?vue&type=style&index=1&id=f383fdcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f383fdcc",
  null
  
)

export default component.exports